import apiClient from "../api/client";

export interface AuditLog {
  id: string;
  user: string | null;
  user_email: string;
  action: string;
  modele: string;
  objet_id: string;
  details: any;
  ip_address: string;
  timestamp: string;
}

export interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const LogsService = {
  async getLogs(page = 1, searchQuery = "") {
    let url = `/auth/logs/?page=${page}`;
    if (searchQuery) {
      url += `&search=${searchQuery}`;
    }
    const response = await apiClient.get<PaginatedResponse<AuditLog>>(url);
    return response.data;
  },
};
